import { signOut } from 'firebase/auth';
import { firebaseAuth } from '@/lib/Firebase';

/** Clears stored API token and Firebase session when the backend rejects auth (401). */
export function clearSessionOnUnauthorized(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem('authToken');
  } catch {
    // Storage may be unavailable (private mode, etc.)
  }
  void signOut(firebaseAuth);
}
